import React from "react";
import {Col, Select, Typography} from "antd";
import {
    CityFilter,
    CourierFilter,
    CourierInvoiceAccountStatusFilter,
    WalletInvoiceVendorFilter,
} from "../../../../_defaultComponents/FilterComponents";

const AllCourierWalletsTabFilters = ({filters, setFilters, options}) => {
    const statuses = [
        {value: "all", label: "Tümü"},
        {value: true, label: "Aktif"},
        {value: false, label: "Pasif"},
    ];

    return (
        <React.Fragment>
            <Col xs={24} sm={12} md={6} lg={4} xl={4}>
                <h5>Kurye (İsim, tckn, telefon)</h5>
                <CourierFilter
                    value={filters.courierId}
                    onChange={value => setFilters({...filters, page: 1, courierId: value})}
                    allowClear={true}
                    selectMarginBottom="0px"
                    activity="all"
                    hideTitle={true}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={4} xl={4}>
                <WalletInvoiceVendorFilter
                    value={filters.courierInvoiceAccountVendor}
                    onChange={value =>
                        setFilters({...filters, page: 1, courierInvoiceAccountVendor: value})
                    }
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={4} xl={4}>
                <CourierInvoiceAccountStatusFilter
                    value={filters.courierInvoiceAccountStatus}
                    onChange={value =>
                        setFilters({...filters, page: 1, courierInvoiceAccountStatus: value})
                    }
                    initialValue={options.invoiceVendors}
                    loading={options.invoiceVendors.loading}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={4} xl={4}>
                <CityFilter
                    value={filters.city}
                    onChange={value => setFilters({...filters, page: 1, city: value})}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={4} xl={4}>
                <Typography.Text>Cüzdan Durumu</Typography.Text>
                <Select
                    style={{width: "100%"}}
                    value={filters.isWalletActive === undefined ? "all" : filters.isWalletActive}
                    onChange={value =>
                        setFilters({
                            ...filters,
                            page: 1,
                            isWalletActive: value === "all" ? undefined : value,
                        })
                    }
                >
                    {statuses.map(item => (
                        <Select.Option key={String(item.value)} value={item.value}>
                            {item.label}
                        </Select.Option>
                    ))}
                </Select>
            </Col>
        </React.Fragment>
    );
};

export default AllCourierWalletsTabFilters;
